export default "__VITE_ASSET__B51R3Ra3__"